import { z, type ZodTypeAny } from 'zod';

export const v4PageEnvelope = z.object({
  last: z.boolean().optional(),
  total_elements: z.number().optional(),
  total_pages: z.number().optional(),
  size: z.number().optional(),
  number: z.number().optional(),
  number_of_elements: z.number().optional(),
  first: z.boolean().optional(),
  empty: z.boolean().optional()
});

export function v4PageOf<Item extends ZodTypeAny>(item: Item) {
  return v4PageEnvelope.extend({ content: z.array(item) });
}
